<template>
  <div
    id="MarqueeCotainer"
    v-if="allMarquee.length > 0"
    @touchstart="MarqueeTouchStart($event)"
    @touchend="MarqueeTouchEnd($event)"
  >
    <transition
      :enter-active-class="'slideIn' + MarqueeInDirecter"
      :leave-active-class="'slideOut' + MarqueeOutDirecter"
    >
      <img
        class="animated"
        @click="
          viewArticle(allMarquee[thisMarquee] + 1, 3, $route.params.class)
        "
        :src="
          require('../assets/3/' +
            (allMarquee[thisMarquee] + 1) +
            '/marquee.jpg')
        "
        :key="thisMarquee"
      />
    </transition>
    <div id="PointCotainer" v-if="allMarquee.length > 1">
      <div
        class="MarqueePoint"
        v-for="p in allMarquee.length"
        :key="p"
        :class="{ ThisMarquee: p == thisMarquee + 1 }"
      ></div>
    </div>
  </div>
</template>

<script>
import articlesStore_3 from "../store/articlesStore_3";
import articlesStore_2 from "../store/articlesStore_2";

import pageStackStore from "../store/pageStackStore";

export default {
  name: "Marquee",
  data() {
    return {
      allMarquee: [],
      thisMarquee: 0,
      MarqueeOutDirecter: "Left",
      MarqueeInDirecter: "Right",
      bannerIsTurning: false,
      intervalID: 0,
      touchVal: {
        x: 0,
        y: 0,
      },
    };
  },
  mounted() {
    this.allMarquee =
      articlesStore_3.state["class" + this.$route.params.class].marquees;
    if (this.allMarquee.length > 1) {
      this.intervalID = setInterval(
        function () {
          this.turnMarquee();
        }.bind(this),
        5000
      );
    }
  },
  methods: {
    viewArticle: function (id, issue, thisclass) {
      pageStackStore.commit("pushPageStack", this.$route.path);
      this.$router.replace({
        name: "Article",
        params: { id, issue, class: thisclass },
      });
    },
    turnMarquee: function (goto) {
      if (this.bannerIsTurning) return false;
      let next = goto == undefined ? this.thisMarquee + 1 : goto;
      if (next >= this.thisMarquee) {
        this.MarqueeOutDirecter = "Left";
        this.MarqueeInDirecter = "Right";
      } else {
        this.MarqueeOutDirecter = "Right";
        this.MarqueeInDirecter = "Left";
      }
      if (next >= this.allMarquee.length) {
        next = 0;
      }
      if (next < 0) {
        next = this.allMarquee.length - 1;
      }
      this.thisMarquee = next;
    },
    MarqueeTouchStart: function (e) {
      this.touchVal.x = e.touches[0].clientX;
    },
    MarqueeTouchEnd: function (e) {
      let p = window.innerWidth / 1125;
      if (e.changedTouches[0].clientX - this.touchVal.x > 50 * p) {
        clearInterval(this.intervalID);
        this.turnMarquee(this.thisMarquee - 1);
        this.intervalID = setInterval(
          function () {
            this.turnMarquee();
          }.bind(this),
          5000
        );
      }
      if (e.changedTouches[0].clientX - this.touchVal.x < -50 * p) {
        clearInterval(this.intervalID);
        this.turnMarquee(this.thisMarquee + 1);
        this.intervalID = setInterval(
          function () {
            this.turnMarquee();
          }.bind(this),
          5000
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
@fullWidth: 11.25rem;
.fullWidhth {
  width: @fullWidth;
}

#MarqueeCotainer {
  .fullWidhth();
  position: relative;

  height: 6.33rem;
  img {
    .fullWidhth();

    position: absolute;
    left: 0px;
    top: 0px;
  }

  #PointCotainer {
    .fullWidhth();

    position: absolute;
    height: 0.3rem;
    top: 5.9rem;
    display: flex;
    justify-content: center;

    .MarqueePoint {
      width: 0.4rem;
      height: 0.1rem;
      border-radius: 0.05rem;
      background: rgb(210, 210, 210);
      margin: 0.1rem;
    }
    .ThisMarquee {
      background: rgb(255, 193, 0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Marquee.vue